export const REASONS_EVENTS = {
  ORDER_FOLLOWING_UP: "ORDER_FOLLOWING_UP",
  ORDER_FOLLOWING_UP_WAIVED_ADDITIONAL_FEES:
    "ORDER_FOLLOWING_UP_WAIVED_ADDITIONAL_FEES",
};
